<template>
  <div class="wrapper-login z-10">
    <div class="card card-login">
      <div class="login-header gradient-donapp">
        <img class="back" src="../../assets/icons/back.png">
        <p class="signup clickable">{{$t('labels.login')}}</p>
        <div class="overlay-logo"></div>
        <img class="donapp-logo" src="../../assets/square-logo.png">
      </div>
      <div class="card-content">
        <popup-input
          class="password-input"
          v-model="password"
          material-icon="lock_outline"
          name="password"
          :label="$t('labels.password')"
          validation="required"
          type="password"
        />
        <popup-input
          class="password-input"
          v-model="confirmPassword"
          material-icon="lock_outline"
          name="confirm-password"
          :label="$t('labels.confirm_password')"
          validation="required"
          type="password"
        />
      </div>
      <div class="text-center mb10">
        <Button :action="newPassword" text="Confirm"/>
      </div>
      <div class="footer-label"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import PopupInput from '@/components/shared/inputs/PopupInput'
import Button from '@/components/shared/buttons/Button'

export default {
  name: 'new-password',
  components: {
    Button,
    PopupInput
  },
  $_veeValidate: {
    validator: 'new' // give me a new validator each time.
  },
  data() {
    return {
      password: '',
      confirmPassword: '',
      token: ''
    }
  },
  mounted: function() {
    this.token = this.$route.query.token
    if (navigator.userAgent.match(/iPhone|iPad|iPod|Android/i)) {
      window.location = 'donapp://app/new-password?token=' + this.token
    }
  },
  computed: {
    ...mapState({
      route: state => state.route
    })
  },
  methods: {
    ...mapActions({
      renewPassword: 'renewPassword'
    }),
    newPassword: function() {
      if (this.password === this.confirmPassword) {
        this.renewPassword({ password: this.password, token: this.token })
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../scss/config.scss';
.login-header {
  position: relative;
  min-height: 160px;
  text-align: center;
  padding: 22px 16px;
  border-radius: 16px 16px 0px 0px;
}

.login-header .header-title {
  font-size: 29px;
  font-weight: 700;
  color: $white;
  text-transform: uppercase;
}

.card-content {
  padding: 0 16px 14px;
  margin-top: -48px;
  position: relative;
  z-index: 2;
}

.wrapper-full-page {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
}

.card-title {
  font-weight: bold;
}

.card {
  border-radius: 16px;
  width: 352px;
  margin: 0 auto;
  z-index: 1;
}

.footer-label {
  text-align: center;
  padding-bottom: 10px;
}

.forgot-button {
  font-size: 10px;
  text-decoration: underline;
  text-decoration-color: $grey;
  cursor: pointer;
}

.remember-me {
  display: flex;
  align-items: center;
}

.login-header .back {
  left: 24px;
  cursor: pointer;
  font-weight: 100;
  width: 20px;
}

.login-header .signup {
  right: 24px;
  width: 55px;
  text-transform: uppercase;
}

.donapp-logo {
  margin: 26px auto;
  width: 150px;
}

.login-header .back,
.login-header .signup {
  position: absolute;
  top: 24px;
  z-index: 11;
  color: #ffffff;
}

.wrapper-login {
  text-align: center;
  padding-top: 32px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.password-input {
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
}

.with-forgot {
  max-height: 0px;
  padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/NewPassword.vue